import { useLoadCurrentUserNetworks } from '@ms/yammer-hooks/dist/currentUserNetworks';
import Flex, { FlexItem } from '@ms/yammer-web-core-ui/dist/components/Flex';
import type { FC, ReactNode } from 'react';
import React from 'react';

export interface AppNavigationHeaderProps {
  readonly title: ReactNode;
  readonly contextMenu: ReactNode;
  readonly searchInput: ReactNode;
}

const AppNavigationHeader: FC<AppNavigationHeaderProps> = ({ title, contextMenu, searchInput }) => {
  useLoadCurrentUserNetworks();

  return (
    <Flex direction="column" rowGap={4} paddingLeft={2} paddingRight={5} paddingBottom={4}>
      <Flex alignItems="center" justifyContent="space-between">
        <FlexItem grow={1}>{title}</FlexItem>
        <FlexItem>{contextMenu}</FlexItem>
      </Flex>
      {searchInput}
    </Flex>
  );
};
export default AppNavigationHeader;
